import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, Alert, TouchableOpacity, ScrollView } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { LoadingHeader, Button, LoadingCover } from '../../component';
import { FontAwesome5 } from '@expo/vector-icons';
import API from '../../API';
import moment from 'moment';

const SELECTED_COLORS = {
	dark: '#2F7A2F',
	light: '#9EF29E',
}

var SeriesRedirect = props=>{
	var { colors, dark } = useTheme();
	var { series, onRedirect } = props.route.params;
	var [options, setOptions] = useState(null);
	var [selectedSeries, setSelectedSeries] = useState(null);
	var [reverse, setReverse] = useState(false);
	var [sending, setSending] = useState(false);

	var selectedColor = SELECTED_COLORS[dark ? 'dark' : 'light'];

	var styles = StyleSheet.create({
		container: {
			backgroundColor: colors.card,
			marginHorizontal: 15,
			borderRadius: 9,
			padding: 10,
			borderWidth: 3
		},
		name: {
			color: colors.text,
			fontSize: 20,
			marginBottom: 5,
		},
		metadata: {
			color: 'gray',
		}
	})

	var getOptions = ()=>{
		API.getRedirectSeries(series.series_id).then(res=>{
			if(res.error){
				Alert.alert('Error', res.message_client);
				return props.navigation.goBack();
			}
			setOptions(res.data.options);
		}).catch(err=>{
			Alert.alert('Error', 'Unexpected error loading series options (LCL-1)');
			return props.navigation.goBack();
		})
	}

	var redirect = ()=>{
		var from, to;
		from = reverse ? selectedSeries : series;
		to = reverse ? series : selectedSeries;
		if(!from || !to) return;
		Alert.alert('Redirect series', `${from.series_name}\nto\n${to.series_name}`, [
			{ style: 'cancel', text: 'Cancel' },
			{ style: 'default', text: 'Apply', onPress: ()=>{
				setSending(true);
				API.redirectSeries(from.series_id, to.series_id).then(res=>{
					setSending(false);
					if(res.error) return Alert.alert('Error', res.message_client);
					if(onRedirect) onRedirect(from, to);
					props.navigation.goBack();
				}).catch(err=>{
					setSending(false);
					Alert.alert('Error', 'Unexpected error setting series redirect (LCL-2)');
				})
			}}
		])
	}
	
	useEffect(()=>{
		getOptions();
	}, []);

	if(!options) return <LoadingHeader text="Loading series redirect" />

	return (
		<View style={StyleSheet.absoluteFill}>
			<View style={[styles.container, { marginTop: 10 }, !reverse ? {} : { borderColor: selectedColor }]}>
				<Text style={styles.name}>{series.series_name}</Text>
				<View>
					<Text style={styles.metadata}>ID: {series.series_id}</Text>
					<Text style={styles.metadata}>{series.books} Book{series.books==1 ? '' : 's'}</Text>
					<Text style={styles.metadata}>Created: {moment.unix(series.date_created).format('YYYY-MM-DD HH:mm')}</Text>
				</View>
			</View>
			<FontAwesome5 name={reverse ? 'arrow-up' : 'arrow-down'} color={'white'} style={{ textAlign: 'center', marginVertical: 10, fontSize: 40, color: 'gray' }} />
			{selectedSeries ? (
				<View>
					<View style={[styles.container, { marginTop: 10 }, reverse ? {} : { borderColor: selectedColor }]}>
						<Text style={styles.name}>{selectedSeries.series_name}</Text>
						<View>
							<Text style={styles.metadata}>ID: {selectedSeries.series_id}</Text>
							<Text style={styles.metadata}>{selectedSeries.books} Book{selectedSeries.books==1 ? '' : 's'}</Text>
							<Text style={styles.metadata}>Created: {moment.unix(selectedSeries.date_created).format('YYYY-MM-DD HH:mm')}</Text>
						</View>
					</View>
					<View style={{ marginTop: 10, flexDirection: 'row', justifyContent: 'center' }}>
						{!sending && (
							<Button width={40} icon="arrow-left" five height={40} onPress={()=>setSelectedSeries(null)} iconStyle={{ marginRight: 0 }} color={'#1D79F3'} />
						)}
						<Button width={200} text="Redirect" height={40} onPress={redirect} style={{ marginHorizontal: 10 }} loading={sending} />
						{!sending && (
							<Button width={40} icon="sync" five height={40} onPress={()=>setReverse(!reverse)} iconStyle={{ marginRight: 0 }} color={'#1D79F3'} />
						)}
					</View>
				</View>
			) : (
				<ScrollView>
					{options.map(a=>(
						<TouchableOpacity key={a.series_id} onPress={()=>setSelectedSeries(a)}>
							<View style={[styles.container, { marginTop: 10 }, !reverse ? {} : { backgroundColor: selectedColor }]}>
								<Text style={styles.name}>{a.series_name}</Text>
								<View>
									<Text style={styles.metadata}>{a.books} Book{a.books==1 ? '' : 's'}</Text>
									<Text style={styles.metadata}>Created: {moment.unix(a.date_created).format('YYYY-MM-DD HH:mm')}</Text>
								</View>
							</View>
						</TouchableOpacity>
					))}
				</ScrollView>
			)}
		</View>
	)
}

export default SeriesRedirect;